export default {"src":"/_next/static/media/return.0d9afb22.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};